module.exports = __webpack_public_path__ + "static/media/map.1b9fe013.svg";